import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { Button, SaveButton, Text } from '@adsk/bim360-matrix-react-components';
import AnimateHeightPopUp from '../../../AnimateHeightPopUp';
import PushpinVisibilityLearnMoreModal from './components/PushpinVisibilityLearnMoreModal';
import { getPushpinVisibilityTextPrefix } from '../../../../utils/issues-helpers';

class PushpinVisibilityPopUp extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showLearnMoreModal: false,
    };

    this.closeLearnMoreModal = this.closeLearnMoreModal.bind(this);
  }

  closeLearnMoreModal() {
    this.setState({ showLearnMoreModal: false });
  }

  renderContent() {
    const stringPathAccordingToVisibility = getPushpinVisibilityTextPrefix(this.props.isPushpinVisible);
    const headerText = T.translate(`preview.pushpinVisibilityPopup.${stringPathAccordingToVisibility}.header`);
    const contentText = T.translate(`preview.pushpinVisibilityPopup.${stringPathAccordingToVisibility}.content`, { identifier: this.props.issueIdentifier });
    const learnMoreButtonText = T.translate('preview.pushpinVisibilityPopup.learnMore');

    return (
      <div className="PushpinVisibilityPopUp__content">
        <div className="PushpinVisibilityPopUp__content-header">{headerText}</div>
        <div className="PushpinVisibilityPopUp__content-text">
          <Text>{contentText}</Text>
          <Button
            styleType={Button.StyleType.INLINE_LINK}
            onClick={() => { this.setState({ showLearnMoreModal: true }); }}
            disabled={this.props.isChangingPushpinVisibility}
          >
            {learnMoreButtonText}
          </Button>
        </div>
      </div>
    );
  }

  renderFooter() {
    const { isPushpinVisible, isChangingPushpinVisibility, onSave, onCancel } = this.props;
    const stringPathAccordingToVisibility = getPushpinVisibilityTextPrefix(isPushpinVisible);
    const saveButtonText = T.translate(`preview.pushpinVisibilityPopup.${stringPathAccordingToVisibility}.save`);
    const saveButtonInProgressText = T.translate(`preview.pushpinVisibilityPopup.${stringPathAccordingToVisibility}.saving`);
    const cancelButtonText = T.translate(`preview.pushpinVisibilityPopup.${stringPathAccordingToVisibility}.cancel`);

    return (
      <div className="PushpinVisibilityPopUp__footer">
        <Button
          key="cancelButton"
          styleType={Button.StyleType.LINK_SECONDARY}
          onClick={onCancel}
          disabled={isChangingPushpinVisibility}
        >
          {cancelButtonText}
        </Button>
        <SaveButton
          key="saveButton"
          onSave={onSave}
          isSaving={isChangingPushpinVisibility}
          saveText={saveButtonText}
          savingText={saveButtonInProgressText}
        />
      </div>
    );
  }

  render() {
    return (
      <AnimateHeightPopUp isOpen={this.props.isOpen}>
        <div className="PushpinVisibilityPopUp">
          {this.renderContent()}
          {this.renderFooter()}
        </div>
        <PushpinVisibilityLearnMoreModal
          show={this.state.showLearnMoreModal}
          container={this.props.modalContainer}
          onDone={this.closeLearnMoreModal}
        />
      </AnimateHeightPopUp>
    );
  }
}

PushpinVisibilityPopUp.displayName = 'PushpinVisibilityPopUp';

PushpinVisibilityPopUp.propTypes = {
  modalContainer: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  issueIdentifier: PropTypes.string.isRequired,
  isPushpinVisible: PropTypes.bool.isRequired,
  isChangingPushpinVisibility: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default PushpinVisibilityPopUp;
